﻿export interface ISwapQualityIssueForReport {
    id: number;
    recipientId: number;
    donorId: number;
    recipientSwapQualityIssueType: number;
    recipientSwapQualityIssueTypes: string[];
    donorSwapQualityIssueType: number;
    donorSwapQualityIssueTypes: string[];
    donorWhyWasKidneyLate: string;
    recipientIssueDescription: string;
    donorIssueDescription: string;
    recipientRootCause: string;
    donorRootCause: string;
    recipientCorrectiveAction: string;
    donorCorrectiveAction: string;
    recipientSurgeon: number;
    recipientSurgeonName: string;
    recipientCenterName: string;
    donorSurgeon: number;
    donorSurgeonName: string;
    donorCenterName: string;
    recipientSurgicalAssistants: string;
    donorSurgicalAssistants: string;
    recipientDidSurgeonDiscussion: boolean;
    donorDidSurgeonDiscussion: boolean;
    recipientPreSurgicalDiscussionDetails: string;
    donorPreSurgicalDiscussionDetails: string;
    recipientPostSurgicalDiscussionDetails: string;
    donorPostSurgicalDiscussionDetails: string;
    administrativeNotes: string;
    recipientHaveOrganQualityConcerns: boolean;
    recipientDidOrganFunctionImmediately: boolean;
    recipientOrganQualityConcernDetails: string;
    recipientIsOrganCurrentlyFunctioning: boolean;
    recipientDoesPatientRequireReplacementKidney: boolean;
    requestInvestigation: boolean;
    reportedSwapQualityIssue: number;
    recipientKidneyPhoto1: string;
    recipientKidneyPhoto2: string;
    recipientKidneyPhoto3: string;
    donorKidneyPhoto1: string;
    donorKidneyPhoto2: string;
    donorKidneyPhoto3: string;
    recipientNoIssuesToReport: boolean;
    donorIssuesToReport: boolean;
    recipientIssuesFinalized: boolean;
    recipientIssuesFinalizedDateTime: string;
    recipientIssuesPendingDateTime: string;
    donorIssuesFinalized: boolean;
    donorIssuesFinalizedDateTime: string;
    donorIssuesPendingDateTime: string;
    replacementKidneyStatus: number;
    donorFinalizedBy: string;
    recipientFinalizedBy: string;
    nephrectomyDate: string;
}
